/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BodyMain } from '../../../../components/Text';
import Spacer from '../../../../components/Spacer';

const FindGroupNoResults = () => (
  <Spacer size="5" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
    <BodyMain className="font-color-meddark-gray">
      <FormattedMessage id="groupsSelect.noGroups.message.text" />
    </BodyMain>
  </Spacer>
);

export default FindGroupNoResults;
